import { useContext } from "react";

import GoogleMapsApiContext from "./GoogleMapsApiContext";

const useGoogleMapsApi = () =>
  useContext(GoogleMapsApiContext);

export default useGoogleMapsApi;
